import ThumbnailGrid from 'Components/Common/ThumbnailGrid/ThumbnailGrid'
import React, { useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { fetchCollectionsThunk } from 'slices/collections/thunk'
import { AppDispatch, RootState } from 'store'
import { textToTitleCase } from 'utils/helpers'

const Collections = () => {

    const collectionsData = useSelector((state: RootState) => state.collections.list)
    const defaultCollections = collectionsData?.default ?? null;
    const collections = collectionsData?.items ?? [];
    const [loading, setLoading] = useState(false);

    const dispatch: AppDispatch = useDispatch();

    useEffect(() => {
        setLoading(true);
        dispatch(fetchCollectionsThunk({})).finally(() => setLoading(false));
    }, [])

    return (
        <div className='page-container'>
            <h3 className='m-0 saved-collection-heading'>Saved Collection</h3>
            {
                loading ? (
                    <div className="collections-grid" style={{ marginTop: '2rem' }}>
                        {
                            Array.from({ length: 4 }).map((_, index) => (
                                <div className="collection-card" key={index}>
                                    <ThumbnailGrid images={[]} />
                                    <div className="collection-info">
                                       <Skeleton height={10} width={100} />
                                       <Skeleton height={10} width={50} />
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                ) : (
                    <div className="collections-grid" style={{ marginTop: '2rem' }}>
                        {
                            defaultCollections?.post &&
                            <Link to={{ pathname: '/collection/all-posts' }} className="collection-card">
                                <ThumbnailGrid images={defaultCollections.post.thumbnail_urls} />
                                <div className="collection-info">
                                    <span className="collection-name">All Posts</span>
                                    <span className="collection-count">
                                        {defaultCollections.post.count} Post{defaultCollections.post.count > 1 ? 's' : ''}
                                    </span>
                                </div>
                            </Link>
                        }
                        {
                            defaultCollections?.account &&
                            <Link to={{ pathname: '/collection/all-creators' }} className="collection-card">
                                <ThumbnailGrid images={defaultCollections.account.thumbnail_urls} />
                                <div className="collection-info">
                                    <span className="collection-name">All Creators</span>
                                    <span className="collection-count">
                                        {defaultCollections.account.count} Creator{defaultCollections.account.count > 1 ? 's' : ''}
                                    </span>
                                </div>
                            </Link>
                        }

                        {collections.map((collection) => {
                            const thumbnails = collection.thumbnail_urls ?? [];
                            return (
                                <Link to={{ pathname: `/collection/${collection.uuid}` }} key={collection.uuid} className="collection-card">
                                    <ThumbnailGrid images={thumbnails} />
                                    <div className="collection-info">
                                        <span className="collection-name">{collection.name}</span>
                                        <span className="collection-count">
                                            {collection.count} {textToTitleCase(collection.type === 'account' ? 'creator' : collection.type)}{collection.count > 1 ? 's' : ''}
                                        </span>
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                )
            }
        </div>
    )
}

export default Collections